import { useMemo } from "react";
import { Box } from "@chakra-ui/layout";
import { formatCurrency } from "@brazilian-utils/brazilian-utils";

import moment from "moment";
import { DividaAcordo } from "core/features/acordo/typings";

function useListagemDividaAcordoColumns() {
  return useMemo(() => {
    return [
      {
        title: "Vencimento",
        render: (original: DividaAcordo) => (
          <Box>{moment(original.dataVencimento).format("DD/MM/YYYY")}</Box>
        ),
      },
      {
        title: "Valor Original",
        render: (original: DividaAcordo) => (
          <Box>R$ {formatCurrency(original.valor || 0)}</Box>
        ),
      },
      {
        title: "Multa",
        render: (original: DividaAcordo) => (
          <Box color="red">R$ {formatCurrency(original.valorMulta || 0)}</Box>
        ),
      },
      {
        title: "Juros",
        render: (original: DividaAcordo) => (
          <Box color="red">R$ {formatCurrency(original.valorJuros || 0)}</Box>
        ),
      },
      {
        title: "Honorários",
        render: (original: DividaAcordo) => (
          <Box color="red">R$ {formatCurrency(original.valorHonorarios || 0)}</Box>
        ),
      },
      {
        title: "Valor Atual",
        render: (original: DividaAcordo) => (
          <Box>
            <strong>R$ {formatCurrency(original.valorTotal || 0)}</strong>
          </Box>
        ),
      },
    ];
  }, []);
}

export default useListagemDividaAcordoColumns;
